import React from 'react';

interface GalleryTitleProps {
    translate: (key: string) => string;
    isCollapsible: boolean;
}

export const GalleryTitle: React.FC<GalleryTitleProps> = ({translate, isCollapsible}) => (
    <div className='gallery-collapsible__title use-common-styles'>
        <span>{translate('HISTORY.VIEW.IMAGES')}</span>
        {isCollapsible && <span className='collapsible-widget-arrow-container'></span>}
    </div>
);
